"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.byDataHook = exports.dataHooks = void 0;
var dataHooks_1 = require("./dataHooks");
Object.defineProperty(exports, "dataHooks", { enumerable: true, get: function () { return dataHooks_1.dataHooks; } });
var byDataHook_1 = require("./byDataHook");
Object.defineProperty(exports, "byDataHook", { enumerable: true, get: function () { return byDataHook_1.byDataHook; } });
//# sourceMappingURL=index.js.map